import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export const reactivateAccount = createAction('REACTIVATE_ACCOUNT');

export const accountReactivated = createAction<TimestampPayload>('ACCOUNT_REACTIVATED');

export const accountReactivationFailed = createAction<TimestampPayload>('ACCOUNT_REACTIVATION_FAILED');
